import { render, staticRenderFns } from "./StatusDropdown.vue?vue&type=template&id=5db0dc73&"
import script from "./StatusDropdown.vue?vue&type=script&lang=js&"
export * from "./StatusDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5db0dc73')) {
      api.createRecord('5db0dc73', component.options)
    } else {
      api.reload('5db0dc73', component.options)
    }
    module.hot.accept("./StatusDropdown.vue?vue&type=template&id=5db0dc73&", function () {
      api.rerender('5db0dc73', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff-engagement/components/StatusDropdown.vue"
export default component.exports